module.exports = __webpack_public_path__ + "img/img98.57bdbe7a.jpg";